import service from '@/api/service/service';
import qs from "qs";

export function getLoginSalt(data = {}) {
  return service({
    url: "/api/index/check_user_salt.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

export function getLogin(data = {}) {
  return service({
    url: "/api/index/login.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

/**
 * 找回密码 - 发送验证码
 * @param {*} data
 */
export function getFindSendCode(data = {}) {
  return service({
    url: "/api/index/find_password_send_verify_code.json",
    method: 'post',
    data: qs.stringify(data)
  });
}

/**
 * 找回密码 - 返回盐
 * @param {*} data
 */
export function getFindSalt(data = {}) {
  return service({
    url: "/api/index/find_password_salt.json",
    method: 'post',
    data: qs.stringify(data)
  });
}

/**
 * 找回密码 - 手机号重置密码
 * @param {*} data
 */
export function getFindPhone(data = {}) {
  return service({
    url: "/api/index/mobile_phone_find_password.json",
    method: 'post',
    data: qs.stringify(data)
  });
}

/**
 * 激活手机号 - 发送验证码
 * @param {*} data
 * @param token
 */
export function getResetSendCode(data = {}, token, userType) {
  return service({
    url: "/api/main/reset_send_verify_code.json",
    method: 'post',
    headers: { "X-Token": token, "X-UserType": userType },
    data: qs.stringify(data),
  });
}

/**
 * 激活手机号 - 重置密码返回盐
 * @param {*} data
 * @param token
 */
export function getResetSalt(data = {}, token, userType) {
  return service({
    url: "/api/main/reset_salt.json",
    method: 'post',
    headers: { "X-Token": token, "X-UserType": userType },
    data: qs.stringify(data),
  });
}

/**
 * 激活手机号 - 重置密码
 * @param {*} data
 * @param token
 */
export function getResetSendVerify(data = {}, token, userType) {
  return service({
    url: "/api/main/verify_mobile_phone.json",
    method: 'post',
    headers: { "X-Token": token, "X-UserType": userType },
    data: qs.stringify(data),
  });
}

/**
 * 用户名-获取手机号
 * @param data - username
 */
export function getMobileInfo(data = {}) {
  return service({
    url: "/api/index/get_mobile_phone.json",
    method: 'post',
    data: qs.stringify(data)
  });
}

/* 失信名单列表 */
export function letDownList(params = {}) {
  return service({
    url: "/api/index/letDownList.json",
    method: 'get',
    params: params,
  });
}

/* 申诉人员查询详情 */
export function getAppealInfo(params = {}) {
  return service({
    url: "/api/index/people_appeal_info.json",
    method: 'get',
    params: params,
  });
}
